var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShieldCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m13 4.674-4.312-1.51-4.313 1.51v3.513c0 2.615 1.743 4.841 4.313 6 2.569-1.159 4.312-3.385 4.312-6zm1.375 3.513c0 3.397-2.338 6.108-5.425 7.386a.7.7 0 0 1-.525 0C5.338 14.295 3 11.583 3 8.187v-4c0-.292.184-.552.46-.648l5-1.75a.7.7 0 0 1 .455 0l5 1.75c.276.096.46.356.46.648z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.644 6.509a.688.688 0 0 1 .987.957l-3.15 3.25a.69.69 0 0 1-.98.008l-1.7-1.7a.688.688 0 0 1 .973-.973L7.98 9.257z"
})));
export default SvgShieldCheck;